import React from 'react'
import { Text, View } from 'react-native'

import { Option } from '../../screens'
import { SecondaryButton } from '../SecondaryButton/SecondaryButton'

interface OptionsButtonsProps {
  options: Option[]
  selectedAnswer: Option | undefined
  onSelectAnswer: (option: Option) => void
}

export const OptionsButtons = ({ options, selectedAnswer, onSelectAnswer }: OptionsButtonsProps) => {
  return (
    <View>
      <Text style={{ color: 'white', textAlign: 'center' }}>Tap to select answer</Text>

      {options.map((option: Option, index: number) => (
        <SecondaryButton
          key={`option-${option.id}`}
          outline={!selectedAnswer || selectedAnswer.text !== option.text}
          disabled={!!selectedAnswer}
          rounded
          blue
          textProps={{ text: option.text }}
          onPress={() => onSelectAnswer(option)}
          style={{ marginTop: 10 }}
        />
      ))}
    </View>
  )
}
